import { render, staticRenderFns } from "./EditorJS.vue?vue&type=template&id=08c1fb55&scoped=true&"
import script from "./EditorJS.vue?vue&type=script&lang=js&"
export * from "./EditorJS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c1fb55",
  null
  
)

export default component.exports